import { Container } from "inversify";
import getDecorators from "inversify-inject-decorators";
const container = new Container();
const { lazyInject } = getDecorators(container, false);

export { container, lazyInject };

export const registerDep = (dep: any) => {
  container.bind(dep).toSelf();
};

export const unregisterDep = (dep: any) => {
  container.isBound(dep) && container.unbind(dep);
};
